import { AccessGrant } from "./accessGrant/accessGrant.js";
import { ArchivedLogsBatch } from "./archivedLogsBatch/archivedLogsBatch.js";
import { AssetIdentity } from "./assetIdentity/assetIdentity.js";
import { CommandGroup } from "./commandGroup/commandGroup.js";
import { CompleteDeviceVersion } from "./commonSubSchemas/completeDeviceVersion.js";
import { DeviceVersion } from "./commonSubSchemas/deviceVersion.js";
import { ExternalLink } from "./commonSubSchemas/externalLink.js";
import { ForeignLookup } from "./commonSubSchemas/foreignLookup.js";
import { ManualOverrideInfo } from "./commonSubSchemas/manualOverrideInfo.js";
import { MessagingChannelAddress } from "./commonSubSchemas/messagingChannelAddress.js";
import { RecentSensorDataPoint } from "./commonSubSchemas/recentSensorDataPoint.js";
import { SensorClusterAddress } from "./commonSubSchemas/sensorClusterAddress.js";
import { SensorElementAddress } from "./commonSubSchemas/sensorElementAddress.js";
import { ValveState } from "./commonSubSchemas/valveState.js";
import { VertexInfo } from "./commonSubSchemas/vertexInfo.js";
import { DefaultLoraNetworkProfilePerDevice } from "./defaultLoraNetworkProfilePerDevice/defaultLoraNetworkProfilePerDevice.js";
import { Device } from "./device/device.js";
import { DeviceStatistics } from "./device/subSchemas/deviceStatistics.js";
import { Gen4NetworkInfo } from "./device/subSchemas/gen4NetworkInfo.js";
import { LoraNetworkProfileConfig } from "./device/subSchemas/loraNetworkProfileConfig.js";
import { SensorSpecifier } from "./device/subSchemas/sensorSpecifier.js";
import { SignalMetrics } from "./device/subSchemas/signalMetrics.js";
import { SoilMoistureEntry } from "./device/subSchemas/soilMoistureEntry.js";
import { SproutAutomationSettings } from "./device/subSchemas/sproutAutomationSettings.js";
import { SproutLastDownlinkInfo } from "./device/subSchemas/sproutLastDownlinkInfo.js";
import { SproutNetworkInfo } from "./device/subSchemas/sproutNetworkInfo.js";
import { SproutRecentPortHistory } from "./device/subSchemas/sproutRecentPortHistory.js";
import { GeneralSproutVerificationCheck } from "./device/subSchemas/sproutVerification/generalSproutVerificationCheck.js";
import { RecentVerificationDataPoint } from "./device/subSchemas/sproutVerification/recentVerificationDataPoint.js";
import { SproutVerificationChecks } from "./device/subSchemas/sproutVerification/sproutVerificationChecks.js";
import { SproutVerificationIndex } from "./device/subSchemas/sproutVerification/sproutVerificationIndex.js";
import { SproutVerificationInfo } from "./device/subSchemas/sproutVerification/sproutVerificationInfo.js";
import { SproutVerificationInstance } from "./device/subSchemas/sproutVerification/sproutVerificationInstance.js";
import { VerificationCheckConfiguration } from "./device/subSchemas/verificationCheckConfiguration.js";
import { DeviceVersionRecord } from "./deviceVersionRecord/deviceVersionRecord.js";
import { DocumentRedirect } from "./documentRedirect/documentRedirect.js";
import { Gen4InternalStateTracker } from "./gen4InternalStateTracker/gen4InternalStateTracker.js";
import { Gen4SensorInternalState } from "./gen4InternalStateTracker/subSchemas/gen4SensorInternalState.js";
import { Gen4SensorSubsystemStates } from "./gen4InternalStateTracker/subSchemas/gen4SensorSubsystemStates.js";
import { Gen4ValveInternalState } from "./gen4InternalStateTracker/subSchemas/gen4ValveInternalState.js";
import { Gen4ValveSubsystemsStates } from "./gen4InternalStateTracker/subSchemas/gen4ValveSubsystemsStates.js";
import { HistoricalDeviceConfiguration } from "./historicalDeviceConfiguration/historicalDeviceConfiguration.js";
import { InboundMessage } from "./inboundMessage/inboundMessage.js";
import { InboundMedia } from "./inboundMessage/subSchemas/inboundMedia.js";
import { IrrigationEvent } from "./irrigationEvent/irrigationEvent.js";
import { IrrigationEventUpcomingActiveDates } from "./irrigationEventUpcomingActiveDates/irrigationEventUpcomingActiveDates.js";
import { IrrigationSet } from "./irrigationSet/irrigationSet.js";
import { LockoutBanner } from "./lockoutBanner/lockoutBanner.js";
import { LoraNetworkProfile } from "./loraNetworkProfile/loraNetworkProfile.js";
import { LoraNetworkProfileSupportedDeviceSelector } from "./loraNetworkProfile/subSchemas/loraNetworkProfileSupportedDeviceSelector.js";
import { ResponsivenessSettings } from "./loraNetworkProfile/subSchemas/responsivenessSettings.js";
import { LorawanDeviceKeys } from "./lorawanDeviceKeys/lorawanDeviceKeys.js";
import { MessagingContact } from "./messagingContact/messagingContact.js";
import { QuietHoursWindow } from "./messagingContact/subSchemas/quietHoursWindow.js";
import { NdviImage } from "./ndviImage/ndviImage.js";
import { NotificationSubscription } from "./notificationSubscription/notificationSubscription.js";
import { NotificationSubscriptionRule } from "./notificationSubscription/subSchemas/notificationSubscriptionRule.js";
import { WarningTypeNotificationMode } from "./notificationSubscription/subSchemas/warningTypeNotificationMode.js";
import { NotificationSubscriptionMembership } from "./notificationSubscriptionMembership/notificationSubscriptionMembership.js";
import { Organization } from "./organization/organization.js";
import { ContactInfo } from "./organization/subSchemas/contactInfo.js";
import { DeviceUpdateTiming } from "./organization/subSchemas/deviceUpdateTiming.js";
import { ImageOverlay } from "./organization/subSchemas/imageOverlay.js";
import { PumpSpecifier } from "./organization/subSchemas/pumpSpecifier.js";
import { UserSMSSettings } from "./organization/subSchemas/userSMSSettings.js";
import { OrganizationInvitation } from "./organizationInvitation/organizationInvitation.js";
import { OutboundMessage } from "./outboundMessage/outboundMessage.js";
import { OwnerMostRecentData } from "./ownerMostRecentData/ownerMostRecentData.js";
import { PeriodicScriptLogs } from "./periodicScriptLogs/periodicScriptLogs.js";
import { PeriodicProcessLogs } from "./periodicScriptLogs/subSchemas/periodicProcessLogs.js";
import { ProductionJigLog } from "./productionJigLog/productionJigLog.js";
import { ResponseTimeStats } from "./responseTimeStats/responseTimeStats.js";
import { ScdTestEntity } from "./scdTestEntity/scdTestEntity.js";
import { SensorCluster } from "./sensorCluster/sensorCluster.js";
import { SensorElement } from "./sensorElement/sensorElement.js";
import { SensorReadingConfiguration } from "./sensorReadingConfiguration/sensorReadingConfiguration.js";
import { CustomSensorTimingRule } from "./sensorReadingConfiguration/subSchemas/customSensorTimingRule.js";
import { SensorTypeReadingConfig } from "./sensorReadingConfiguration/subSchemas/sensorTypeReadingConfig.js";
import { SensoterraDevice } from "./sensoterraDevice/sensoterraDevice.js";
import { SentDownlink } from "./sentDownlink/sentDownlink.js";
import { Site } from "./site/site.js";
import { SproutLogger } from "./sproutLogger/sproutLogger.js";
import { LoggerDownlinkResponse } from "./sproutLogger/subSchemas/loggerDownlinkResponse.js";
import { LoggerFlags } from "./sproutLogger/subSchemas/loggerFlags.js";
import { LoggerParsedDownlink } from "./sproutLogger/subSchemas/loggerParsedDownlink.js";
import { LoggerParsedUplink } from "./sproutLogger/subSchemas/loggerParsedUplink.js";
import { LoggerPayload } from "./sproutLogger/subSchemas/loggerPayload.js";
import { LoggerSchedule } from "./sproutLogger/subSchemas/loggerSchedule.js";
import { LoggerTimes } from "./sproutLogger/subSchemas/loggerTimes.js";
import { ThirdPartyApiCredential } from "./thirdPartyApiCredential/thirdPartyApiCredential.js";
import { ThirdPartyApiCredentialActivity } from "./thirdPartyApiCredentialActivity/thirdPartyApiCredentialActivity.js";
import { HeatAndFrostProtection } from "./thirdPartyDevice/subSchemas/heatAndFrostProtection.js";
import { ThirdPartyDevice } from "./thirdPartyDevice/thirdPartyDevice.js";
import { TtiApplication } from "./ttiApplication/ttiApplication.js";
import { UserAccount } from "./userAccount/userAccount.js";
import { VersionEventActor } from "./versionEvent/subSchemas/versionEventActor.js";
import { VersionEvent } from "./versionEvent/versionEvent.js";
import { WarningFixEntry } from "./warning/subSchemas/warningFixEntry.js";
import { WarningProblemEntry } from "./warning/subSchemas/warningProblemEntry.js";
import { Warning } from "./warning/warning.js";
import { CurrentIntendedState } from "./zone/subSchemas/currentIntendedState.js";
import { SoilLayer } from "./zone/subSchemas/soilLayer.js";
import { SupplementalZoneDataStream } from "./zone/subSchemas/supplementalZoneDataStream.js";
import { SupplementalZoneGraphInfo } from "./zone/subSchemas/supplementalZoneGraphInfo.js";
import { ZoneMetadata } from "./zone/subSchemas/zoneMetadata.js";
import { Zone } from "./zone/zone.js";

/**
 * All Verdi Models need to be added here in order to function correctly wth the findGetters function
 * (and generally work well in the rest of the system).
 *
 * Attempts were made to make this more dry, but it seems like this format is required for typescript to figure it out.
 */
export const allVerdiSchemas = {
    [ArchivedLogsBatch.schemaKey]: ArchivedLogsBatch,
    [RecentSensorDataPoint.schemaKey]: RecentSensorDataPoint,
    [TtiApplication.schemaKey]: TtiApplication,
    [VertexInfo.schemaKey]: VertexInfo,
    [Organization.schemaKey]: Organization,
    [ContactInfo.schemaKey]: ContactInfo,
    [DeviceUpdateTiming.schemaKey]: DeviceUpdateTiming,
    [ImageOverlay.schemaKey]: ImageOverlay,
    [PumpSpecifier.schemaKey]: PumpSpecifier,
    [UserSMSSettings.schemaKey]: UserSMSSettings,
    [OwnerMostRecentData.schemaKey]: OwnerMostRecentData,
    [PeriodicProcessLogs.schemaKey]: PeriodicProcessLogs,
    [PeriodicScriptLogs.schemaKey]: PeriodicScriptLogs,
    [DocumentRedirect.schemaKey]: DocumentRedirect,
    [LorawanDeviceKeys.schemaKey]: LorawanDeviceKeys,
    [ProductionJigLog.schemaKey]: ProductionJigLog,
    [SensorTypeReadingConfig.schemaKey]: SensorTypeReadingConfig,
    [CustomSensorTimingRule.schemaKey]: CustomSensorTimingRule,
    [SensorReadingConfiguration.schemaKey]: SensorReadingConfiguration,
    [Gen4InternalStateTracker.schemaKey]: Gen4InternalStateTracker,
    [SentDownlink.schemaKey]: SentDownlink,
    [CommandGroup.schemaKey]: CommandGroup,

    // Device-related schemas
    [Device.schemaKey]: Device,
    [ThirdPartyDevice.schemaKey]: ThirdPartyDevice,
    [HeatAndFrostProtection.schemaKey]: HeatAndFrostProtection,
    [HistoricalDeviceConfiguration.schemaKey]: HistoricalDeviceConfiguration,

    // Third-party API credentials
    [ThirdPartyApiCredential.schemaKey]: ThirdPartyApiCredential,
    [ThirdPartyApiCredentialActivity.schemaKey]: ThirdPartyApiCredentialActivity,

    // Device-related subSchemas
    [DeviceStatistics.schemaKey]: DeviceStatistics,
    [SproutVerificationInfo.schemaKey]: SproutVerificationInfo,
    [SproutVerificationIndex.schemaKey]: SproutVerificationIndex,
    [SproutVerificationInstance.schemaKey]: SproutVerificationInstance,
    [SproutVerificationChecks.schemaKey]: SproutVerificationChecks,
    [GeneralSproutVerificationCheck.schemaKey]: GeneralSproutVerificationCheck,
    [RecentVerificationDataPoint.schemaKey]: RecentVerificationDataPoint,
    [SproutRecentPortHistory.schemaKey]: SproutRecentPortHistory,
    [SproutLastDownlinkInfo.schemaKey]: SproutLastDownlinkInfo,
    [SproutAutomationSettings.schemaKey]: SproutAutomationSettings,
    [SproutNetworkInfo.schemaKey]: SproutNetworkInfo,
    [SensorSpecifier.schemaKey]: SensorSpecifier,
    [SoilMoistureEntry.schemaKey]: SoilMoistureEntry,
    [Gen4NetworkInfo.schemaKey]: Gen4NetworkInfo,
    [SignalMetrics.schemaKey]: SignalMetrics,
    [Gen4SensorInternalState.schemaKey]: Gen4SensorInternalState,
    [Gen4SensorSubsystemStates.schemaKey]: Gen4SensorSubsystemStates,
    [Gen4ValveInternalState.schemaKey]: Gen4ValveInternalState,
    [Gen4ValveSubsystemsStates.schemaKey]: Gen4ValveSubsystemsStates,
    [VerificationCheckConfiguration.schemaKey]: VerificationCheckConfiguration,
    [LoraNetworkProfileConfig.schemaKey]: LoraNetworkProfileConfig,

    [LoraNetworkProfile.schemaKey]: LoraNetworkProfile,
    [ResponsivenessSettings.schemaKey]: ResponsivenessSettings,
    [LoraNetworkProfileSupportedDeviceSelector.schemaKey]: LoraNetworkProfileSupportedDeviceSelector,
    [DefaultLoraNetworkProfilePerDevice.schemaKey]: DefaultLoraNetworkProfilePerDevice,

    // AssetIdentity schemas
    [AssetIdentity.schemaKey]: AssetIdentity,

    // ResponseTimeStats schemas
    [ResponseTimeStats.schemaKey]: ResponseTimeStats,

    // Common subSchemas
    [ForeignLookup.schemaKey]: ForeignLookup,
    [ExternalLink.schemaKey]: ExternalLink,
    [ManualOverrideInfo.schemaKey]: ManualOverrideInfo,
    [ValveState.schemaKey]: ValveState,
    [DeviceVersion.schemaKey]: DeviceVersion,
    [CompleteDeviceVersion.schemaKey]: CompleteDeviceVersion,
    [SensorClusterAddress.schemaKey]: SensorClusterAddress,
    [SensorElementAddress.schemaKey]: SensorElementAddress,
    [MessagingChannelAddress.schemaKey]: MessagingChannelAddress,

    // Warning
    [Warning.schemaKey]: Warning,
    [WarningFixEntry.schemaKey]: WarningFixEntry,
    [WarningProblemEntry.schemaKey]: WarningProblemEntry,

    // Device versions
    [DeviceVersionRecord.schemaKey]: DeviceVersionRecord,

    // Lockout banner
    [LockoutBanner.schemaKey]: LockoutBanner,

    // User accounts and organization access
    [UserAccount.schemaKey]: UserAccount,
    [OrganizationInvitation.schemaKey]: OrganizationInvitation,
    [AccessGrant.schemaKey]: AccessGrant,

    // SMS notification pipeline
    [MessagingContact.schemaKey]: MessagingContact,
    [QuietHoursWindow.schemaKey]: QuietHoursWindow,
    [NotificationSubscription.schemaKey]: NotificationSubscription,
    [NotificationSubscriptionRule.schemaKey]: NotificationSubscriptionRule,
    [WarningTypeNotificationMode.schemaKey]: WarningTypeNotificationMode,
    [NotificationSubscriptionMembership.schemaKey]: NotificationSubscriptionMembership,
    [OutboundMessage.schemaKey]: OutboundMessage,

    // Inbound message schemas
    [InboundMessage.schemaKey]: InboundMessage,
    [InboundMedia.schemaKey]: InboundMedia,

    // VersionEvent (SCD Type 2 audit sidecar)
    [VersionEvent.schemaKey]: VersionEvent,
    [VersionEventActor.schemaKey]: VersionEventActor,

    // ScdTestEntity (SCD Type 2 test fixture)
    [ScdTestEntity.schemaKey]: ScdTestEntity,

    // Sensor cluster and element schemas
    [SensorCluster.schemaKey]: SensorCluster,
    [SensorElement.schemaKey]: SensorElement,

    // Zone-related schemas
    [Zone.schemaKey]: Zone,
    [CurrentIntendedState.schemaKey]: CurrentIntendedState,
    [SoilLayer.schemaKey]: SoilLayer,
    [SupplementalZoneGraphInfo.schemaKey]: SupplementalZoneGraphInfo,
    [SupplementalZoneDataStream.schemaKey]: SupplementalZoneDataStream,
    [ZoneMetadata.schemaKey]: ZoneMetadata,

    // Site schemas
    [Site.schemaKey]: Site,

    // IrrigationEvent schemas
    [IrrigationEvent.schemaKey]: IrrigationEvent,
    [IrrigationEventUpcomingActiveDates.schemaKey]: IrrigationEventUpcomingActiveDates,

    // SensoterraDevice schemas
    [SensoterraDevice.schemaKey]: SensoterraDevice,

    // NdviImage schemas
    [NdviImage.schemaKey]: NdviImage,

    // IrrigationSet schemas
    [IrrigationSet.schemaKey]: IrrigationSet,

    // SproutLogger schemas
    [SproutLogger.schemaKey]: SproutLogger,
    [LoggerDownlinkResponse.schemaKey]: LoggerDownlinkResponse,
    [LoggerFlags.schemaKey]: LoggerFlags,
    [LoggerParsedDownlink.schemaKey]: LoggerParsedDownlink,
    [LoggerParsedUplink.schemaKey]: LoggerParsedUplink,
    [LoggerPayload.schemaKey]: LoggerPayload,
    [LoggerSchedule.schemaKey]: LoggerSchedule,
    [LoggerTimes.schemaKey]: LoggerTimes,
} as const satisfies Record<string, new (...args: any) => { schemaKey: string }>;

export type VerdiSchemaKey = keyof typeof allVerdiSchemas;

export type VerdiSchema = InstanceType<(typeof allVerdiSchemas)[VerdiSchemaKey]>;
